import Blue from "~/core";

new Blue({
	name: 'Date Picker',
	selector: ".datePicker input",
	setup(input) {
		this.$pickit(input);
	}
});

new Blue({
	name: 'Form Validate',
	selector: ".form--validate",
	setup(form) {
		this.$validate(form);
	}
});


new Blue({
    name: "Feedback Message Max Length",
    selector: "textarea[name*=Feedback]",
    setup: function(e) {
        if (!e.hasAttribute("maxlength"))
            e.setAttribute("maxlength", 256);

        const maxlength = e.getAttribute("maxlength");
        let currentLength = 0;

        e.insertAdjacentHTML('beforebegin', `<p class="form-maxlength-text">${maxlength} characters left</p>`);
        const maxlengthText = e.previousElementSibling;

        (function updateMaxlengthText() {
            requestAnimationFrame(updateMaxlengthText);

            if (e.value.length === currentLength)
                return;

            currentLength = e.value.length;
            const remaining = maxlength - currentLength;
            maxlengthText.innerText = `${remaining} character${remaining === 1 ? '' : 's'} left`;
        })();
    }
});